/**
 * 我的页面 - 主入口
 */

import { ProfileHeader } from "./components/ProfileHeader";
import { AccountInfoCard } from "./components/AccountInfoCard";
import { InsuranceCodesCard } from "./components/InsuranceCodesCard";
import { ChangePasswordModal } from "./components/ChangePasswordModal";
import { useProfile } from "./hooks/useProfile";
import styles from "./Profile.module.css";

export function Profile() {
  const {
    userInfo,
    isModalOpen,
    loading,
    form,
    insuranceCompanies,
    handleOpenChangePassword,
    handleCloseChangePassword,
    handleChangePassword,
    handleLogout,
  } = useProfile();

  return (
    <div className={styles.profilePage}>
      {/* 标题栏 */}
      <div className={styles.headerRow}>
        <div className={styles.title}>我的</div>
      </div>

      <div
        style={{
          flex: 1,
          height: 0,
          overflowY: "auto",
          padding: "24px 16px 0",
        }}
      >
        {/* 用户信息横幅 */}
        <ProfileHeader userInfo={userInfo} />

        {/* 内容区域 */}
        <div className={styles.profileContent}>
          <div className={styles.cardsGrid}>
            {/* 账号信息卡片 */}
            <AccountInfoCard
              userInfo={userInfo}
              onChangePassword={handleOpenChangePassword}
              onLogout={handleLogout}
            />

            {/* 保司工号卡片 */}
            {/* <InsuranceCodesCard companies={insuranceCompanies} /> */}
          </div>
        </div>

        {/* 修改密码弹窗 */}
        <ChangePasswordModal
          open={isModalOpen}
          loading={loading}
          form={form}
          onCancel={handleCloseChangePassword}
          onFinish={handleChangePassword}
        />
      </div>
    </div>
  );
}
